export default __webpack_public_path__ + "static/media/dragable.9fc0d1d4.svg";